import React, { Component, PureComponent } from 'react';
import './Dialogs.min.css';

class PDFPrintDialog extends PureComponent {
    constructor(props) {
        super(props);
}

    shouldComponentUpdate(){
        return false;
    }

    render() {
        var width = "705";
        var height = "705";
        //var uuid = generateUUID();
        var uuid = "MTS_Actuator_Design_" + new Date().getTime().toString().slice(6); //create unique name
        //update iframe url
        var url = this.props.urlDW2 + "/Integration?run=MTS_201_Sales&Transition=Print&PdfName=" + uuid;
        var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

        var customer = [];
        customer.push("CustFirstName=" + this.props.customer.firstName);
        customer.push("CustLastName=" + this.props.customer.lastName);
        customer.push("CustEmail=" + this.props.customer.email);
        customer.push("CustCompany=" + this.props.customer.company);
        customer.push("CustPhone=" + this.props.customer.phone);
        customer.push("CustCountry=" + this.props.customer.country);
        customer.push("CustProject=" + this.props.customer.projectName);
        url+= "&" + customer.join("&");

        for(var i = 0; i < this.props.data.parameters.length; i++){
            url+= "&" + this.props.data.parameters[i].dwVar + "=" + (parseInt(this.props.data.parameters[i].choice) + 1); //set to default
        }

        var iframe = document.querySelector("#test_iframe");
        iframe.src = url //send current setup to second iframe tied to another instance of the DW stuff
        console.log("sent = " + url);

        //call pdfwatcher webservice to watch for the new 'guid'.pdf file
        let params = {"guid": uuid};
        let query = Object.keys(params).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k])).join('&'); //encode the querystring parameters
        let pdf_url = this.props.urlSite + '/pdfwatcher/server.js?' + query;

        fetch(pdf_url)
        .then(response => response.json())
        .then(data => handleGuid(data, this)) //pass showPopup function along to avoid scope issues
        .catch(error => handleError(error, this)); //pass scope along with error

        function handleGuid(guid, scope){
            var dlg_spinner = document.querySelector(".dlg_print_spinner");
            var dlg_iframe = document.querySelector(".dlg_iframe");
            var dlg_print_btn = document.querySelector("#dlg_print_btn");
            var dlg_download_btn = document.querySelector("#dlg_download_btn");
            var urlSite = scope.props.urlSite;
            dlg_iframe.src = urlSite + "/pdfwatcher/pdfs/" + guid.guid + ".pdf";
            dlg_spinner.style.display = "none";
            dlg_iframe.style.display = "block";

            if(!isFirefox){ //doesn't work in Firefox, ancient bug
                 dlg_print_btn.style.display = "inline-flex";
                 dlg_print_btn.addEventListener('click', function (e) {
                     dlg_iframe.contentWindow.print();
                     e.preventDefault();
                });
            }
            dlg_download_btn.href = dlg_iframe.src;
            dlg_download_btn.style.display = "inline-flex";

        }
          
        function handleError(error, scope){
            this.props.onClick(null);
        }

        function generateUUID() { // Public Domain/MIT
            var d = new Date().getTime();
            if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
                d += performance.now(); //use high-precision timer if available
            }
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = (d + Math.random() * 16) % 16 | 0;
                d = Math.floor(d / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }
        return (
            <div id="dlg_pdf" className="dialog">
                <div className="dlg_modal">
                    <div className="dlg_title">
                        <img src="images/mtsLogo.png" />
                        <div className="dlg_title_txt">Configuration PDF</div>
                        <div className="dlg_exit" onClick={() => this.props.onClick(null)}>X</div>
                    </div>
                    <div className="dlg_content">
                        <div className="dlg_white">
                            <div className="dlg_print_spinner">
                                <img src="images/spinner.gif"/>
                                <p className="dlg_head">Generating PDF...</p>
                            </div>
                            <iframe className="dlg_iframe"></iframe>
                        </div>
                        <div id="dlg_quote_btn" className="dlg_btn" onClick={() => this.props.onClick(null)}>EXIT</div>
                        <a id="dlg_download_btn" className="dlg_btn" download="print.pdf" style={{display: "none"}}>DOWNLOAD</a>
                        <div id="dlg_print_btn" className="dlg_btn" style={{display: "none"}}>PRINT</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PDFPrintDialog;
